import commonAction from './commonAction';
import * as types from '../constants/actionsTypes';

export const exportData = (category_id) => {
	return dispatch =>
		commonAction(dispatch, 'post', '/settings/category-report', {category_id}, 'EXPORT_DATA', 'exportData')
}

export const clearExportLink = () => {
	return {
		type: types.CLEAR_EXPORT_LINK
	}
}

export const saveSettingValue = (settings) => {
	let sm = [];
	for(let key of Object.keys(settings))
	{
		sm.push({code: key, value: settings[key]})
	}

	return dispatch =>
		commonAction(
			dispatch,
			'post',
			'/settings/update',
			sm,
			'UPDATE_COEFFICIENT',
			'response'
		)
}

export const clearMessages = (form) => {
	return {
		type: types.CLEAR_ALERT_MESSAGES,
		form
	}
}

export const loadCultures = () => {
	return dispatch => commonAction(dispatch, 'post', '/cultures', {}, 'LOAD_CULTURES', 'list')
}

export const saveCulture = data => {
	return dispatch => commonAction(dispatch, 'post', '/cultures/save', data, 'SAVE_CULTURE', 'list')
}

export const deleteCulture = data => {
	return dispatch => commonAction(dispatch, 'post', '/cultures/delete', data, 'DELETE_CULTURE', 'list')
}


// WEBPACK FOOTER //
// ./actions/settingsActions.js